import { render } from "./EditMailAccount.vue?vue&type=template&id=a3b2f4bc&scoped=true"
import script from "./EditMailAccount.vue?vue&type=script&lang=js"
export * from "./EditMailAccount.vue?vue&type=script&lang=js"

import "./EditMailAccount.vue?vue&type=style&index=0&id=a3b2f4bc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3b2f4bc"]])

export default __exports__